import { connect } from 'react-redux';
import { notifySet } from '../Services/Actions/CommonActions';

const mapDispatchToProps = (dispatch) => ({
  notify: (data) => {
    dispatch(notifySet(data));
  },
});

const mapStateToProps = (state) => ({
  notifyValue: state.notify ? state.notify : null,
});

export default connect(mapStateToProps, mapDispatchToProps);
